<template>
  <div class="choose-provider">
    <h1 class="page__title">{{ title }}</h1>
    <picture class="choose-provider__img">
      <source
        v-for="(image, index) in screenshot.images"
        :key="index"
        :media="image.media"
        :srcset="image.url"
      />
      <img :src="screenshot.default_image" :alt="screenshot.title" />
    </picture>
    <div class="choose-provider__text">
      {{ text }}
    </div>

    <div class="choose-provider__filter">
      <label class="choose-provider__filter-label" for="choose-provider-zip">
        Deine Postleitzahl hilft uns dich bei der<br />Auswahl des Providers zu
        unterstützen:
      </label>
      <input
        class="choose-provider__zip"
        type="number"
        max="9999"
        id="choose-provider-zip"
        v-model="zip"
      />

      <LinkButton text="Auswählen" @click.native="submit" />
    </div>

    <div
      :class="{
        'choose-provider__items': true,
        'choose-provider__items--suggested': hasZipValue,
      }"
    >
      <div
        :class="{
          'choose-provider__item-wrapper': true,
          'choose-provider__item-wrapper--suggested':
            index === suggestedProvider,
        }"
        v-for="(provider, index) in providers"
        :key="provider.shortName"
        target="_blank"
      >
        <h5
          class="choose-provider__suggested"
          v-if="hasZipValue && index === suggestedProvider"
        >
          Unsere Empfehlung für deine Region
        </h5>

        <div class="choose-provider__item">
          <h4 class="choose-provider__name">
            {{ provider.name }}
          </h4>
          <a
            :href="provider.supplierSignupUrl"
            target="_blank"
          >
            <img
              class="choose-provider__logo"
              :src="provider.logoUrl"
              :alt="provider.name"
            />
          </a>
          <a
            :href="provider.tariffDetailsUrl"
            target="_blank"
            class="choose-provider__tariff-link"
          >
            {{ t('chooseProvider.tariffLink') }}

            <IconExternal />
          </a>

          <ul v-if="false" class="choose-provider__features">
            <li v-for="(item, index) in provider.features" :key="index">
              {{ item }}
            </li>
          </ul>

          <a
            :href="provider.supplierSignupUrl"
            target="_blank"
            class="button button--primary choose-provider__signup"
          >
            {{ t('chooseProvider.signup') }}
            <IconExternal />
          </a>
        </div>
      </div>
    </div>
    <!-- newsletter -->
    <div class="newsletter">
      <Newsletter v-if="submitted" />
    </div>
  </div>
</template>

<script>
import LinkButton from '@/components/LinkButton.vue';
import Newsletter from '@/components/forms/Newsletter.vue';
import IconExternal from '@/components/icons/External.vue';
import { useStrings } from '@/composables/useStrings.ts';
import { CHOOSE_PROVIDERS } from '@/constants';
import { useAppStore } from '@/stores/useAppStore';
import { useAuthStore } from '@/stores/useAuthStore';
import { computed, ref, watch } from 'vue';

  export default {
    name: 'choose-provider',
    components: {
      LinkButton,
      IconExternal,
      Newsletter,
    },
    props: {
      context: {
        type: String,
        default: 'home',
      },
    },
    setup(props) {
      const appStore = useAppStore()
      const authStore = useAuthStore()
      const { t } = useStrings()

      const context = ref(props.context)
      const zip = ref('1010')
      const submitted = ref(false)
      const hasZipValue = computed(() => {
        const value = zip.value + ''
        return value && value.length > 3
      })

      const suggestedProvider = ref(0)

      const submit = () => {
        document
          .getElementsByClassName('layout__content--nav')[0]
          .scrollBy({ left: 0, top: 600, behavior: 'smooth' })
        submitted.value = true
      }

      const providers = computed(() => {
        if (submitted.value) {
          // && window.innerWidth <= BP_SSM
          // const intZip = parseInt(zip.value)
          // return store.getters.providers.sort((a, b) => {
          //   const zipDiffA = Math.abs(parseInt(a.zip) - intZip)
          //   const zipDiffB = Math.abs(parseInt(b.zip) - intZip)
          //   return zipDiffA - zipDiffB
          // })
          let providers = appStore.providers
          let efriends = providers.find(
            (provider) => provider.shortName === 'efriends'
          )
          let email = encodeURIComponent(authStore.userName)
          if (efriends.supplierSignupUrl.includes('referralCode=ABCDE')) {
            efriends.supplierSignupUrl = efriends.supplierSignupUrl.replace(
              'referralCode=ABCDE',
              `form[Email]=${email}&form[referral]=tour&form[tourEmail]=${email}`
            )
          }
          return zip.value.match(/^[569]/)
            ? providers.sort((a, b) => (a.shortName === 'gutmann' && b ? -1 : 1))
            : providers.sort((a, b) => (a.shortName === 'gutmann' && b ? 1 : -1))
        }
        return []
      })
      const title = computed(() => {
        return t(`chooseProvider.${context.value}.title`)
      })
      const text = computed(() => {
        return t(`chooseProvider.${context.value}.text`)
      })
      const screenshot = computed(() => {
        if (!(context.value in CHOOSE_PROVIDERS)) {
          return false
        }
        return CHOOSE_PROVIDERS[context.value]
      })

      watch(
        () => props.context,
        (newValue) => {
          context.value = newValue
        }
      )
      return {
        providers,
        title,
        text,
        screenshot,
        zip,
        suggestedProvider,
        hasZipValue,
        submit,
        submitted,
        t,
      }
    },
  }
</script>

<style lang="scss">
  .choose-provider {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: $spacer30;

    .page__title {
      flex-basis: 100%;

      @media (min-width: $bp-md) {
        margin-bottom: $spacer30;
        text-align: center;
      }
    }

    &__img {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;

      @media (max-width: ($bp-ssm - 1px)) {
        order: 2;
        flex-basis: 50%;
      }

      @media (min-width: $bp-ssm) {
        margin-left: auto;
        margin-right: auto;
      }

      img {
        max-width: 130px;
        height: auto;

        @media (min-width: $bp-sm) {
          max-width: 100%;
        }
      }
    }

    &__text {
      margin: $spacer30 auto;

      @media (min-width: $bp-ssm) {
        text-align: center;
        flex-basis: 80%;
      }
    }

    &__filter {
      text-align: center;
      flex-basis: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-bottom: $spacer20;

      @media (max-width: ($bp-ssm - 1px)) {
        margin-top: $spacer20;
        order: 2;
      }

      &-label {
        display: block;
        margin-bottom: $spacer025;
        flex-basis: 100%;
      }

      .button--primary {
        margin-top: 0;
      }
    }

    &__zip {
      max-width: 8rem;
      display: block;
      margin: 0 $spacer10;
    }

    &__items {
      order: 3;
      margin-top: $spacer10;
      flex-basis: 100%;

      @media (min-width: $bp-ssm) {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
      }

      &--suggested {
        .choose-provider__item-wrapper:not(.choose-provider__item-wrapper--suggested)
          .choose-provider__item {
          box-shadow: none;

          .button--primary {
            background: $grey-light;

            @include hover-focus-active {
              background: color.adjust($grey-light, $lightness: -5%);
            }
          }
        }

        .choose-provider__item-wrapper--suggested {
          margin-top: 0;
        }
      }
    }

    &__item {
      @media (min-width: $bp-ssm) {
        padding: $spacer10;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
      }

      &-wrapper {
        display: flex;
        flex-direction: column;
        order: 3;
        margin-top: $spacer20;

        @media (min-width: $bp-ssm) {
          width: 49%;
          margin-top: $spacer30;
          margin-left: 10%;
          margin-right: 10%;
        }
      }
    }

    &__suggested {
      margin-bottom: 0;
      text-align: center;
      font-weight: $font-weight-bold;
      font-size: $font-size-sm;
      line-height: $spacer20;

      @media (min-width: $bp-ssm) {
        line-height: $spacer30;
        font-size: $font-size-base;
      }
    }

    &__logo {
      width: 100%;
      height: 5rem;
      background: $grey-lightest;
      padding: $spacer20;
      transition: $transition-base;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (min-width: $bp-sm) {
        padding: $spacer30 $spacer40;
        height: 7rem;
      }

      img {
        width: 100%;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }

    &__name {
      font-size: $font-size-xs;
      margin-top: $spacer025;
      margin-bottom: $spacer025;
      color: $body-color;
      font-weight: $font-weight-bold;
      text-align: center;

      @media (min-width: $bp-sm) {
        font-size: $font-size-sm;
      }
    }

    &__tariff-link {
      display: flex;
      font-size: $font-size-sm;
      text-align: center;
      margin: $spacer025 0 $spacer025;
      justify-content: center;
      align-items: center;
      color: $body-color;

      @media (max-width: ($bp-xs - 1px)) {
        font-size: $font-size-xs;
      }

      .icon {
        margin-left: $spacer025;
        width: 1em;
        height: 1em;
      }
    }

    &__features {
      margin: $spacer10 0;
      line-height: $line-height-sm;
      padding: 0 0 0 $spacer30;

      @media (max-width: ($bp-ssm - 1px)) {
        font-size: $font-size-sm;
        padding: 0 0 0 $spacer10;
      }
    }

    &__item {
      .button--primary {
        margin-top: auto;
        display: block;

        @media (max-width: ($bp-ssm - 1px)) {
          font-size: $font-size-sm;
          padding-left: $spacer025;
          padding-right: $spacer025;
        }
      }
    }

    &__signup {
      .icon {
        // Hide the icon on small screens to fix the 2 call to action buttons on
        // a single line.
        @media (max-width: ($bp-xs - 1px)) {
          display: none;
        }
      }
    }
  }
  .newsletter {
    order: 4;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    flex-basis: 100%;
    margin-top: 1rem;
  }
</style>
